module.exports = __webpack_public_path__ + "095f779257a4c389ace6acd83cd35810.MP3";